module.exports = __webpack_public_path__ + "img/map_produttore.41c0b858.png";